var _rect, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_115_2368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_115_2368)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9727 5.03906L26.395 16.6083L29.2763 9.78238L41.9727 5.03906Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01196 5.03906L21.4644 16.7178L18.7241 9.78238L6.01196 5.03906Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3676 31.8569L32.219 38.2134L41.096 40.6552L43.648 31.9979L36.3676 31.8569Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36768 31.9979L6.90396 40.6552L15.7809 38.2134L11.6323 31.8569L4.36768 31.9979Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2802 21.1168L12.8062 24.859L21.6201 25.2505L21.3074 15.7788L15.2802 21.1168Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7042 21.1169L26.599 15.6694L26.395 25.2506L35.194 24.8591L32.7042 21.1169Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.781 38.2133L21.0725 35.6298L16.5009 32.0601L15.781 38.2133Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9116 35.6298L32.2189 38.2133L31.4832 32.0601L26.9116 35.6298Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2189 38.2134L26.9116 35.6299L27.3346 39.0901L27.2873 40.5457L32.2189 38.2134Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.781 38.2134L20.7126 40.5457L20.6811 39.0901L21.0725 35.6299L15.781 38.2134Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7908 29.7748L16.376 28.4752L19.4912 27.0503L20.7908 29.7748Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1936 29.7748L28.4933 27.0503L31.6242 28.4752L27.1936 29.7748Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7812 38.2134L16.5326 31.8569L11.6326 31.9979L15.7812 38.2134Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4675 31.8569L32.219 38.2134L36.3676 31.9979L31.4675 31.8569Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.194 24.8594L26.395 25.2508L27.2095 29.7752L28.5091 27.0507L31.6401 28.4755L35.194 24.8594Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3759 28.4755L19.5068 27.0507L20.7907 29.7752L21.6201 25.2508L12.8062 24.8594L16.3759 28.4755Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8062 24.8594L16.5011 32.0602L16.3759 28.4755L12.8062 24.8594Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6401 28.4755L31.4834 32.0602L35.1941 24.8594L31.6401 28.4755Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6202 25.251L20.7908 29.7753L21.8242 35.1133L22.0589 28.0842L21.6202 25.251Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3948 25.251L25.9727 28.0685L26.1601 35.1133L27.2093 29.7753L26.3948 25.251Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2093 29.7747L26.1602 35.1128L26.9116 35.6295L31.4832 32.0598L31.6399 28.4751L27.2093 29.7747Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.376 28.4751L16.5012 32.0598L21.0728 35.6295L21.8243 35.1128L20.7908 29.7747L16.376 28.4751Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2872 40.5457L27.3345 39.09L26.943 38.7451H21.041L20.6811 39.09L20.7126 40.5457L15.781 38.2134L17.5028 39.6217L20.9938 42.0485H26.9903L30.497 39.6217L32.2188 38.2134L27.2872 40.5457Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9116 35.63L26.1602 35.1133H21.8241L21.0726 35.63L20.6812 39.0902L21.0411 38.7452H26.9431L27.3346 39.0902L26.9116 35.63Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6303 17.3597L43.9606 10.9725L41.9726 5.03906L26.9116 16.2168L32.7041 21.1169L40.8919 23.5122L42.7082 21.3989L41.9253 20.8357L43.1777 19.6928L42.2073 18.9414L43.4597 17.9859L42.6303 17.3597Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03955 10.9725L5.36992 17.3597L4.52475 17.9859L5.77714 18.9414L4.82249 19.6928L6.07488 20.8357L5.29194 21.3989L7.09254 23.5122L15.2803 21.1169L21.0728 16.2168L6.01186 5.03906L4.03955 10.9725Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8921 23.512L32.7043 21.1167L35.1941 24.8589L31.4834 32.0597L36.3677 31.9975H43.6481L40.8921 23.512Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.28 21.1167L7.09221 23.512L4.36768 31.9975H11.6323L16.5009 32.0597L12.8059 24.8589L15.28 21.1167Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3949 25.2509L26.9117 16.2172L29.292 9.78271H18.7239L21.0727 16.2172L21.6201 25.2509L21.8084 28.0999L21.8241 35.1132H26.1602L26.1917 28.0999L26.3949 25.2509Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0787665,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_2368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 37.088,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.674fe1bb81699a53b87f5bc0ecc1db3f.svg";
export { ForwardRef as ReactComponent };